var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11816_294799)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.66663,
    width: 43.1842,
    height: 43.1842,
    rx: 21.5921,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2599 30.5889V23.1916C23.2599 22.6317 23.2599 22.3518 23.3689 22.138C23.4647 21.9499 23.6176 21.7969 23.8057 21.7011C24.0195 21.5921 24.2995 21.5921 24.8593 21.5921H27.6583C28.2181 21.5921 28.4981 21.5921 28.7119 21.7011C28.9 21.7969 29.0529 21.9499 29.1488 22.138C29.2577 22.3518 29.2577 22.6317 29.2577 23.1916V30.5889M16.2625 19.0931L25.2992 12.3155C25.6433 12.0574 25.8154 11.9284 26.0043 11.8786C26.1711 11.8347 26.3465 11.8347 26.5133 11.8786C26.7023 11.9284 26.8743 12.0574 27.2185 12.3155L36.2552 19.0931M18.2617 17.5936V27.39C18.2617 28.5097 18.2617 29.0696 18.4796 29.4972C18.6713 29.8734 18.9772 30.1793 19.3533 30.371C19.781 30.5889 20.3409 30.5889 21.4606 30.5889H31.0571C32.1768 30.5889 32.7366 30.5889 33.1643 30.371C33.5405 30.1793 33.8463 29.8734 34.038 29.4972C34.2559 29.0696 34.2559 28.5097 34.2559 27.39V17.5936L28.1781 13.0353C27.4898 12.5191 27.1457 12.261 26.7678 12.1615C26.4341 12.0737 26.0835 12.0737 25.7499 12.1615C25.3719 12.261 25.0278 12.5191 24.3395 13.0353L18.2617 17.5936Z",
    stroke: "#6C757D",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.26641,
    y: 0.599781,
    width: 41.9847,
    height: 41.9847,
    rx: 20.9923,
    stroke: "#EAECF0",
    strokeWidth: 1.19956
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11816_294799",
    x: 0.975665,
    y: 0,
    width: 50.5661,
    height: 50.5655,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.69096
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84548
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.150694 0 0 0 0 0.361313 0 0 0 0 0.645833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11816_294799"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11816_294799",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/AddressIcon.7a2000e5eb1a8af7ae00d62e340fec29.svg";
export { ForwardRef as ReactComponent };